import { Card } from '@mantine/core';

export default Card.extend({
	defaultProps: {
		shadow: 'sm',
		padding: 'lg',
		radius: 'md'
	}
});
